module.exports = __webpack_public_path__ + "static/neihu10-3c228fcca5976ecf09d2dfb334b216ac.jpg";